module.exports = __webpack_public_path__ + "static/media/task-de.b0db9f1d.jpeg";